/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilteredQuery } from '../../models/filtered-query';
import { GetLocationsReportQueryResult } from '../../models/get-locations-report-query-result';
import { SortedQuery } from '../../models/sorted-query';

export interface ApiLocationGetLocationsReportGet$Plain$Params {
  DistrictId?: string;
  LocationId?: string;
  Year?: number;
  Month?: number;
  IsVisited?: boolean;
  PageNumber?: number;
  PageSize?: number;
  Filters?: Array<FilteredQuery>;
  Sorts?: Array<SortedQuery>;
  SearchTerm?: string;
}

export function apiLocationGetLocationsReportGet$Plain(http: HttpClient, rootUrl: string, params?: ApiLocationGetLocationsReportGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLocationsReportQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiLocationGetLocationsReportGet$Plain.PATH, 'get');
  if (params) {
    rb.query('DistrictId', params.DistrictId, {});
    rb.query('LocationId', params.LocationId, {});
    rb.query('Year', params.Year, {});
    rb.query('Month', params.Month, {});
    rb.query('IsVisited', params.IsVisited, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('Filters', params.Filters, {});
    rb.query('Sorts', params.Sorts, {});
    rb.query('SearchTerm', params.SearchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetLocationsReportQueryResult>;
    })
  );
}

apiLocationGetLocationsReportGet$Plain.PATH = '/api/Location/GetLocationsReport';
